<template>
	<a class="list-group-item list-group-item-action justify-content-between d-flex" :href="url" @click.prevent="click">
		<span>{{description}} <span v-if="badge" class="badge badge-danger">{{badge}}</span></span>
		<span class="text-muted">{{detail}}</span>
	</a>
</template>

<script>
	import router from '../router'

	export default {
		name: 'ListGroupItem',
		props: ['description','detail', 'url', 'badge'],
		methods: {
			click(event) {
				this.$emit('item-click');
				if (this.url) router.push(this.url);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ListGroupItem.vue